export default "__VITE_ASSET__DTzoJd2m__"